import {
  configureApiRuntime,
  createCognitoTokenReader,
} from '@consolidocs-ui/data-access';

// See apps/main/src/apiRuntime.ts — imported first in main.tsx.
configureApiRuntime({
  default: {
    baseUrl: import.meta.env.VITE_BACKEND_URL,
    getToken: createCognitoTokenReader(
      import.meta.env.VITE_COGNITO_AUTH_AUTHORITY,
      import.meta.env.VITE_COGNITO_AUTH_CLIENT_ID
    ),
  },
});
